import { render, staticRenderFns } from "./illumina-ele.vue?vue&type=template&id=5608b27c&scoped=true&"
import script from "./illumina-ele.vue?vue&type=script&lang=js&"
export * from "./illumina-ele.vue?vue&type=script&lang=js&"
import style0 from "./illumina-ele.vue?vue&type=style&index=0&id=5608b27c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5608b27c",
  null
  
)

export default component.exports